import { account } from '../lib/appwrite';
import { ID } from 'appwrite';

export const createEmailAccount = async (email: string, password: string, name?: string) => {
  return await account.create(ID.unique(), email, password, name ?? email.split('@')[0]);
};

export const createEmailSession = async (email: string, password: string) => {
  return await account.createEmailPasswordSession(email, password);
};

export const createAnonymousSession = async () => {
  return await account.createAnonymousSession();
};

export const getAccount = async () => {
  try {
    return await account.get();
  } catch (e) {
    return null;
  }
};

export const logout = async () => {
  try {
    await account.deleteSession('current');
  } catch (e) {
    // ignore
  }
};